module.exports = __webpack_public_path__ + "img/healthPro3-EN.3ff26736.png";